import React from 'react';
import AnimateHeight from 'react-animate-height';

export default function Accordion({ children, in: inProp }) {
  const height = inProp ? 'auto' : 0;
  return (
    <AnimateHeight duration={250} height={height}>
      {children}
    </AnimateHeight>
  );
}
